import React, { cloneElement, isValidElement } from "react";
import { Tooltip } from "@songtradr-one/components-frontend";
import { useAppContext } from "../../context/app-context/AppContext";
import { Props } from "./Restricted.Parts";

export const Restricted = ({
  children,
  permissions,
  matchAll = false,
  tooltip,
}: Props) => {
  const { hasAnyPermission, hasAllPermissions } = useAppContext();

  const showToolTipOrHide = !permissions
    ? false
    : matchAll
      ? !hasAllPermissions(permissions)
      : !hasAnyPermission(permissions);

  if (showToolTipOrHide && tooltip) {
    let disabledChildren = children;

    if (isValidElement(children)) {
      // Cast children to a known ReactElement type
      const element = children as React.ReactElement<{ disabled?: boolean }>;

      // Check if it's a known HTML element that supports disabled or a React component
      const supportsDisabled =
        (typeof element.type === "string" &&
          [
            "button",
            "input",
            "select",
            "textarea",
            "fieldset",
            "optgroup",
            "option",
          ].includes(element.type)) ||
        // For custom React components (functions or forwardRef objects)
        typeof element.type === "function" ||
        (typeof element.type === "object" && element.type !== null);

      if (supportsDisabled) {
        disabledChildren = cloneElement(element, {
          ...element.props,
          disabled: true,
        });
      }
    }

    return <Tooltip tip={tooltip}>{disabledChildren}</Tooltip>;
  }

  if (showToolTipOrHide) return null;

  return children;
};
